@if (!standalone) {
  <kb-control-container
    [showError]="showError"
    [controlId]="controlId"
    #controlContainerElement
  >
    <ng-container *ngTemplateOutlet="inputTemplate; context: {controlContainerElement:controlContainerElement}" />
    <kb-label><ng-content /> {{required && showRequired ? ' *' : ''}}</kb-label>
    <ng-content select="kb-hint" ngProjectAs="kb-hint" />
    <ng-content select="kb-error" ngProjectAs="kb-error" />
  </kb-control-container>
} @else {
  <ng-container [ngTemplateOutlet]="inputTemplate" />
}

<ng-template #inputTemplate let-controlContainerElement="controlContainerElement">
  <label class="input-container"> <!--This needs to be a label to support focus on icon click -->
    <input
      [id]="controlId"
      ngDefaultControl
      [attr.aria-label]="ariaLabel"
      [attr.aria-describedby]="controlContainerElement ? controlContainerElement.hintElement?.id : null"
      [attr.type]="type"
      [attr.autocomplete]="autocomplete"
      [attr.placeholder]="placeholder"
      [attr.required]="required ? '' : null"
      [tabindex]="tabindex"
      [attr.step]="step"
      [attr.min]="min"
      [attr.max]="max"
      [name]="name"
      #input
    >
    <ng-content select="[slot='trailer']" />
  </label>
</ng-template>
